// O backend às vezes devolve um objeto no lugar de uma string (ex.: o POST de
// /appointments responde { appointmentId, message }, e erros de validação
// respondem um objeto). Renderizar objeto como filho quebra o React, então
// toda mensagem passa por aqui antes de chegar ao Snackbar.
export default function toMessageText(message, fallback) {
  if (typeof message === 'string') return message;
  if (message === null || message === undefined) return '';
  if (typeof message === 'object' && typeof message.message === 'string') return message.message;
  return fallback;
}
